import { map } from 'rxjs/operators';
import { LoadStatus } from './models/load-status.model';

export interface AccountPreference {
  key: string;
  value: string;
}

export function shouldHideComponentsForBnyReportOnlyAccess(
  userStatus: LoadStatus,
  preferences: AccountPreference[] | null,
  isFeatureEnabled: boolean,
  reportAccessOnlyPreferenceKey: string
): boolean {
  if (userStatus !== LoadStatus.Loaded || !isFeatureEnabled || !preferences || !Array.isArray(preferences)) {
    return false;
  }

  const hasReportAccessOnly = preferences.some(
    pref => pref.key === reportAccessOnlyPreferenceKey && pref.value === 'true'
  );

  return hasReportAccessOnly;
}

export function mapToBnyReportOnlyAccessRestriction(reportAccessOnlyPreferenceKey: string) {
  return map(([userStatus, preferences, isFeatureEnabled]: [LoadStatus, AccountPreference[] | null, boolean]) =>
    shouldHideComponentsForBnyReportOnlyAccess(userStatus, preferences, isFeatureEnabled, reportAccessOnlyPreferenceKey)
  );
}
